import axios from '../../../common/api/axios';

export const createMrq = async ({ createdMrq }) => {
  const { data } = await axios.post('/mrq', createdMrq);
  console.log(data);
  return data;
};
